import yup from "modules/form-validation"

export const password = yup
  .string()
  .min(8)
  .max(128)
  .matches(/[A-Za-z]/, "Deve conter ao menos uma letra")
  .matches(/[0-9]/, "Deve conter ao menos um número")
  .matches(/[^A-Za-z0-9]/, "Deve conter ao menos um simbolo")
